// Navbar.tsx
import React, { useState } from 'react';
import { Button, Grid, Image } from 'semantic-ui-react';
// @ts-ignore
import ModernCulpaIcon from '../../icons/modern-culpa.svg';
import MenuButton from './buttons/MenuButton';
import MobileMenu from './MobileMenu';
import SearchBar from './SearchBar';

const Navbar: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const toggleMenu = (): void => setMenuOpen(!menuOpen);

    return (
        <>
            <Grid className="navbar culpa-blue">
                <div className="navbar__row">
                    <Button
                        className="navbar__logo-button culpa-blue"
                        href="/home"
                    >
                        <Image
                            src={ModernCulpaIcon}
                            alt="Culpa Icon"
                            className="culpa-icon-size"
                        />
                    </Button>
                    <SearchBar />
                    <Button
                        className="orange-button desktop-only"
                        content="WRITE A REVIEW"
                        href="/review/new"
                    />
                    <MenuButton onClick={toggleMenu} />
                </div>
            </Grid>

            <MobileMenu open={menuOpen} onClose={toggleMenu} />
        </>
    );
};

export default Navbar;
